import styled from "styled-components";
import { BTTO_PROFILE_COLORS } from "../../shared/elements";

export const SecurityCardRoot = styled.article`
	display: flex;
	flex-direction: column;
	gap: 12px;
	padding: 16px;
	border-radius: 12px;
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	min-height: 180px;
`;

export const SecurityCardHeader = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 8px;
`;

export const SecurityCardIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 36px;
	height: 36px;
	border-radius: 8px;
	background: ${BTTO_PROFILE_COLORS.surface};
	color: ${BTTO_PROFILE_COLORS.textMuted};

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const SecurityStatusIcon = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;

	svg {
		width: 20px;
		height: 20px;
	}
`;

export const SecurityCardTitle = styled.h3`
	margin: 0;
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	font-weight: 600;
	line-height: 1.3;
`;

export const SecurityCardDescription = styled.p`
	margin: 0;
	flex: 1;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 400;
	line-height: 1.5;
`;

export const SecurityCardAction = styled.div`
	margin-top: auto;
`;
